import { FormatCreateAndUpdate } from '../../pages/userSchedule/pages/detail/typing'
import { Constants } from '../../utils/constants'
import { Http } from '../../utils/types'
import { GetBlob } from '../../utils/types/generals'
import { ReportUrl, SectionScheduldeQuestionnaire } from '../schedule/response'
import {
  AssignScheduleDetail,
  AssignScheduleErrors,
  AssignScheduleMoreErrors,
  DeleteUserScheduleInterface,
} from './response'

const UserServiceSchedule = (client: Http) => ({
  getList: async (data?: {
    query?: string
  }): Promise<AssignScheduleMoreErrors> =>
    await client.get(
      `user-questionnaire${data?.query ? '?' + data?.query : ''}`
    ),
  getDetail: async ({ id }: { id: string }): Promise<AssignScheduleDetail> =>
    await client.get(`user-questionnaire/${id}`),
  getQuestionarieById: async (id: number | string): Promise<Array<SectionScheduldeQuestionnaire>> => await client.get(`questionnaires/detail?userQuestionnaireId=${id}`),
  createrUserSchedule: async ({
    body,
  }: {
    body: FormatCreateAndUpdate[]
  }): Promise<AssignScheduleErrors> =>
    await client.post('user-questionnaire', body),
  updateUserSchedule: async ({
    body,
    id,
  }: {
    body: FormatCreateAndUpdate
    id: string
  }): Promise<AssignScheduleErrors> =>
    await client.put(`user-questionnaire/${id}`, body),
  updateUserScheduleRecurrent: async ({
    body,
    id,
  }: {
    body: FormatCreateAndUpdate
    id: string
  }): Promise<AssignScheduleErrors> =>
    await client.put(`user-questionnaire/recurrent/${id}`, body),
  updateUserScheduleSerie: async ({
    body,
    id,
  }: {
    body: FormatCreateAndUpdate
    id: number
  }): Promise<AssignScheduleErrors> =>
    await client.put(`user-questionnaire/serie/${id}`, body),
  deleteScheduleRecurrent: async (id: string) => await client.delete(`user-questionnaire/${id}`),
  deleteScheduleSerie: async (id: string) => await client.delete(`user-questionnaire/serie/${id}`),
  deleteScxheduleMasive: async (body: DeleteUserScheduleInterface, query?: string) => await client.post(`user-questionnaire/massive/delete${query ? `?${query}` : ''}`, body),
  downloadReport: async (data: {
    type: `pdf` | 'word' | 'excel'
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `user-questionnaire/generate-file?type=${data.type}${data?.query ? `${data?.query}` : ''
      }`
    ),
  closeUserSchedule: async ({ id }: { id: string | number }) =>
    await client.put(`user-questionnaire/close/${id}`),

  getGenerateReport: async ({ id }: { id: number | string }): Promise<ReportUrl> => await client.get(`user-questionnaire/${id}/generate-report`, 'json', { signal: AbortSignal.timeout(Constants.abortTime['10min']) })
})

export { UserServiceSchedule }
